<template>
  <b-container v-if="logineoCalendar">
    <CalendarList />
  </b-container>
  <b-container v-else>
    <CalendarHeader />
    <hr>
    <CalendarNavigation />
    <CalendarDisplay />
    <CalendarCalendarsList />
  </b-container>
</template>

<script>
import { BContainer } from 'bootstrap-vue'
import CalendarNavigation from '@/components/Calendar/CalendarNavigation'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CalendarHeader from '@/components/Calendar/CalendarHeader'
import CalendarDisplay from '@/components/Calendar/CalendarDisplay'
import CalendarCalendarsList from '@/components/Calendar/CalendarCalendarsList'
import CalendarList from '@/components/Calendar/LogineoCalendar/CalendarList'

export default {
  name: 'CalendarWrapper',
  components: {
    CalendarList,
    CalendarCalendarsList,
    CalendarDisplay,
    CalendarHeader,
    CalendarNavigation,
    BContainer
  },
  computed: {
    ...mapGetters('calendar', [
      'getMonth',
      'getYear'
    ]),
    ...mapGetters('config', [
      'getConfig',
      'configIsLoaded'
    ]),
    config () {
      if (!this.configIsLoaded) {
        return []
      }
      return this.getConfig
    },
    logineoCalendar () {
      return this.config.LOGINEO_CALENDAR === 'true'
    },
    month () {
      return this.getMonth
    },
    year () {
      return this.getYear
    }
  },
  watch: {
    month () {
      this.reloadEvents()
    },
    year () {
      this.reloadEvents()
    }
  },
  mounted () {
    this.SET_TODAY()
    this.fetchCalendars()
    this.reloadEvents()
  },
  methods: {
    ...mapActions('calendar', [
      'fetchEvents',
      'fetchCalendars'
    ]),
    ...mapMutations('calendar', [
      'SET_TODAY'
    ]),
    reloadEvents () {
      if (this.getMonth === 1) {
        this.fetchEvents({
          year: this.getYear - 1,
          month: 12
        })
      } else {
        this.fetchEvents({
          year: this.getYear,
          month: this.getMonth - 1
        })
      }
      this.fetchEvents({
        year: this.getYear,
        month: this.getMonth
      })
      if (this.getMonth === 12) {
        this.fetchEvents({
          year: this.getYear + 1,
          month: 1
        })
      } else {
        this.fetchEvents({
          year: this.getYear,
          month: this.getMonth + 1
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
